export default __webpack_public_path__ + "static/media/queue.e51561cf.png";